export enum SeasonType {
    Regular = 'REGULAR',
    Playoff = 'PLAYOFF',
    All = 'ALL'
}